import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import useChatPanelStore from 'stateManagement/store/useChatPanelStore';
import { z } from 'zod';

import {
  useGetSessionById,
  useRenameSession_Mutation,
} from 'stateManagement/queries/services/aiChat/aiChatQueries';

import ControlledInput from 'blockscope/components/blockscopeCommon/ControlledInput';

const formSchema = z.object({
  newName: z
    .string()
    .min(2, 'Name must be at least 2 characters long')
    .max(50, 'Name must be less than 50 characters long'),
});

const RenameSessionModal = ({ authReducer: { user } }) => {
  const [show, setShow] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(formSchema) });

  const { mutate: renameSession, isLoading: isRenamingSession } =
    useRenameSession_Mutation();
  const onSubmit = (data) => {
    if (!chatSessionId) return;
    renameSession({ sessionId: chatSessionId, name: data.newName });
    setShow(false);
  };
  const chatSessionId = useChatPanelStore((state) => state.chatSessionId);
  const { data: chatData } = useGetSessionById(chatSessionId);
  return chatSessionId && chatData?.createdBy?._id === user._id ? (
    <>
      <Button
        onClick={() => setShow(!show)}
        size='sm'
        className='me-2'
        variant='falcon-primary'
        disabled={isRenamingSession}
      >
        <FontAwesomeIcon icon={'pencil'} />
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Rename</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Label>New Name</Form.Label>
            <ControlledInput
              control={control}
              paramName='newName'
              placeholder='New Name'
            />

            {errors.newName && (
              <p className='text-danger fs--2'>{errors.newName.message}</p>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='falcon-secondary'
            size='sm'
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>
          <Button
            variant='falcon-primary'
            size='sm'
            onClick={handleSubmit(onSubmit)}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  ) : null;
};

export default connect((state) => ({
  authReducer: state.authReducer,
}))(RenameSessionModal);
